export var Envs;
(function (Envs) {
    Envs["production"] = "production";
    Envs["sandbox"] = "sandbox";
    Envs["dev"] = "dev";
    Envs["test"] = "test";
})(Envs || (Envs = {}));
export var Apps;
(function (Apps) {
    Apps["junior"] = "junior";
    Apps["abc"] = "abc";
})(Apps || (Apps = {}));
//# sourceMappingURL=Utils.js.map